export default class AddStockUtil {

    static extractNumber(str) {
        const match = str.match(/(\d+)$/);
        return match ? parseInt(match[0], 10) : 0;
    }

    static mergeCollectionItems(allLabelledStockData, AddedProducts, designId) {
        const id = parseInt(designId);
        return [
            ...allLabelledStockData.filter((x) => x.DesignId === id),
            ...AddedProducts.filter((x) => x.DesignId === id && x.ItemCode !== ""),
        ];
    }

    static findLastCollectionItem(totalCollectionItem) {
        return totalCollectionItem.reduce(
            (max, item) => {
                const maxCode = this.extractNumber(max.ItemCode) || 0;
                const currentCode = this.extractNumber(item.ItemCode) || 0;
                return currentCode > maxCode ? item : max;
            },
            { ItemCode: "" }
        );
    }

    static parseLastCollectionItemId(lastCollectionItemId) {
        const match = lastCollectionItemId.match(/^(.+?)(\d+)$/);
        if (match) {
            return { prefix: match[1], number: parseInt(match[2], 10) };
        }
        return { prefix: lastCollectionItemId, number: 0 };
    }

    static generateItemCode({
        designId,
        AddedProducts,
        allLabelledStockData,
        collectionTypeData,
        from,
    }) {
        const totalCollectionItem = this.mergeCollectionItems(
            allLabelledStockData,
            AddedProducts,
            designId
        );

        console.log("Merged items:", totalCollectionItem);

        const lastCollectionItem = this.findLastCollectionItem(totalCollectionItem);

        let lastCollectionItemId =
            totalCollectionItem.length > 0
                ? lastCollectionItem.ItemCode
                : collectionTypeData.find((x) => x.Id == designId)?.LabelCode || "";

        console.log("Last Collection Item ID:", lastCollectionItemId);

        const { prefix, number } = this.parseLastCollectionItemId(
            lastCollectionItemId
        );

        console.log("Parsed Item Code:", { prefix, number });

        if (from === "middle") {
            return { number, prefix };
        }

        if (from === "grid") {
            const newNumber = number + 1;
            return `${prefix}${newNumber}`;
        }
    }


    static changeinputvisiblity({ key, itemfields, visible, place }) {
        return itemfields.map((field) => {
          if (field.key === key && field.place === place) {
            return { ...field, visibility: visible };
          }
          return field;
        });
      }


    static changeinputvisiblity1({key, itemfields, setItemfields, visible, place, index}){

        
        
        
        if (key === "PackingWeight") {
            setItemfields((prevFields) =>
              prevFields.map((field) => {
                if (
                  [
                    "ClipQuantity",
                    "ClipWeight",
                    "OtherWeight",
                    "PouchWeight",
                    "TagWeight",
                    "FindingWeight",
                  ].includes(field.key) &&
                  field.place === place
                ) {
                    
                  return {
                    ...field,
                    visibility: 'ReadOnly', // Ensure other fields in the grid remain editable
                  };
                }
                return field;
              })
            );
          } else if (
            [
              "ClipQuantity",
              "ClipWeight",
              "OtherWeight",
              "PouchWeight",
              "TagWeight",
              "FindingWeight",
            ].includes(key)
          ) {
            setItemfields((prevFields) =>
              prevFields.map((field) => {
                if (field.key === "PackingWeight" && field.place === place) {
                  return {
                    ...field,
                    visibility: 'ReadOnly', // Ensure PackingWeight remains editable in the grid
                  };
                }
                return field;
              })
            );
          }
        };



}